<template>
  <ul ref="target" class="menu dropdown-content z-[1] w-52 bg-base-100 p-2 shadow">
    <slot></slot>
  </ul>
</template>
<script lang="ts" setup>
  import { onClickOutside } from '@vueuse/core';
  import { ref } from 'vue';
  const target = ref(null);
  const emit = defineEmits<{ (e: 'close'): void }>();

  onClickOutside(target, () => emit('close'));
</script>
